export const MCF_REDIRECT_STATES: readonly string[] = Object.freeze(['app', 'app1', 'app2', 'app3', 'app4', 'app5', 'stage']);
